module.exports = __webpack_public_path__ + "img/ic_food_function_store_img.738463e0.png";